import React, { useEffect } from 'react';
import Text from '@components/text';
import Wrapper from '@components/wrapper.styled';
import Section from '@components/section';
import { defaultTheme } from '@styles/theme.styled';
import { RichTextBlock } from 'prismic-reactjs';
import { StyledFormContainer, HubSpotForm, TitleContainer } from './cta-newsletter.styled';

declare global {
  interface Window {
    hbspt: {
      forms: {
        create: (config: { portalId: string; formId: string; target: string }) => void;
      };
    };
  }
}

export interface EnclosedNewsletterFormProps {
  title?: string;
  description?: RichTextBlock[];
  backgroundColor: keyof typeof defaultTheme.backgroundColors;
  formId: string;
  portalId: string;
}

const CTANewsletter = ({
  title,
  description,
  formId,
  backgroundColor,
  portalId,
}: EnclosedNewsletterFormProps): JSX.Element => {
  const EmbeddedForm = () => {
    return (
      <Section backgroundColor={backgroundColor}>
        <Wrapper>
          <StyledFormContainer>
            <TitleContainer>
              {title && (
                <Text
                  tag="h3"
                  fontColor="white"
                  type="title"
                  fontSize="heading3"
                  stringText={title}
                  margin="none"
                />
              )}
              {description && (
                <Text
                  type="subheading"
                  richText={description}
                  margin="none"
                  fontColor="white"
                  fontSize="large"
                />
              )}
            </TitleContainer>
            <HubSpotForm id="hubspotForm" />
          </StyledFormContainer>
        </Wrapper>
      </Section>
    );
  };

  useEffect(() => {
    if (!formId || !portalId) return;

    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/embed/v2.js';
    document.body.appendChild(script);

    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId,
          formId,
          target: '#hubspotForm',
        });
      }
    });
  }, [formId, portalId]);

  return formId && portalId ? <EmbeddedForm /> : <></>;
};

export default CTANewsletter;
